<template>
    <div class="help-page content-wrap sun">
        <div class="page-content error" v-if="/error/.test(status)">
            <img src="http://guokrapp-static.guokr.com/FtVEW1rYFi2sG3g3oxLA6uNvDLA_" v-show="status === 'error_user'" alt=""/>
            <img src="http://guokrapp-static.guokr.com/Fm1EFpWZXU4dQsWCs11H8psPlXtj" v-show="status === 'error_time'" alt=""/>
            <p class="error-tip" v-if="status === 'error_time'">
                {{`该题目已过期\n求助仅限当日有效哦`}}
            </p>
            <p class="error-tip" v-else>
                不可以求助自己哦
            </p>
        </div>
        <div class="page-content question" v-else>
            <div class="invite-info" v-if="uid && status === 'normal'">{{nickname}}邀请你帮ta回答以下问题</div>
            <div v-if="status === 'normal'" class="question-wrap que-content-warp">
                <div ref="content">
                    <Question
                        :question="quiz"
                        :val.sync="val"
                    ></Question>
                </div>
            </div>
            <Button
                class="btn btn-primary content-bottom-wrap "
                v-if="status === 'normal'"
                :disabled="!canNext"
                @click="handleSubmit"
            >提交</Button>
        </div>
        <Dialog
            v-model="dialogVisible"
            :show-confirm-button="false"
            :close-on-popstate="true"
        >
            <div class="dialog-content">
                <img src="http://guokrapp-static.guokr.com/FnNS3Pks7pgcC1Z1GkoFaSSl2SqR" v-show="isRight"/>
                <img src="http://guokrapp-static.guokr.com/FtKbrWXZUexaS0F-c7Jo8e7oLLgY" v-show="!isRight"/>

                <p class="result-word">{{isRight ? '恭喜你答对了！' : '很遗憾，答错了！'}}</p>

                <p class="welcome-word">
                    {{`点击按钮，立即参加\n“朝阳区公民科学素质大赛”\n赢积分，得好礼！`}}
                </p>
                <button class="btn btn-primary welcome-button" @click="location.replace('/quiz')">我要参加</button>
            </div>
        </Dialog>
    </div>
</template>

<script>
import { userApi, quizApi } from '@/apis'
import Question from '@/components/Question'
import { Button, Dialog } from 'vant'

const isToday = (date) => {
    return new Date(new Date(date).getTime()).setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0)
}

export default {
    components: {
        Question,
        Button,
        'Dialog': Dialog.Component
    },
    data () {
        return {
            user: {},
            quiz: {},
            val: {},
            status: '',
            uid: '',
            dialogVisible: false,
            isRight: true,
        }
    },
    computed: {
        canNext () {
            return !!(typeof this.val.seq_id === 'number' || this.val.multi_answer_seq_num && this.val.multi_answer_seq_num.length)
        }
    },
    methods: {
        initData () {
            this.quizId = Number(this.$route.query?.quizId)
            this.resultId = Number(this.$route.params?.resultId)
        },
        async getPageInfo () {
            const { quiz, created_at, uid, nickname } = await this.getQuiz()
            
            if (!isToday(`${created_at}+00:00`)) {
                this.status = 'error_time'
            } else {
                const logined = await this.$auth.check({ showModal: false })
                if (logined === uid) {
                    this.status = 'error_user'
                    console.log('不能求助自己')
                } else {
                    // this.user = user
                    this.uid = uid
                    this.nickname = nickname
                    this.quiz = quiz
                    this.status = 'normal'
                }
            }
        },
        async getUserInfo (uid) {
            return (await userApi.userUidGet({
                params: {
                    uid
                }
            })).body
        },
        async getQuiz () {
            const {body} = await quizApi.resultResultIdHelpGet({
                params: {
                    resultId: this.resultId,
                    quiz_id: this.quizId
                }
            })
            return body
        },
        async handleSubmit () {
            if (!this.canNext) return
            const isRight = (await quizApi.quizResultCheckPost({
                body: {
                    quiz_id: this.quizId,
                    answer_seq_num: this.val.seq_id,
                    multi_answer_seq_num: this.val.multi_answer_seq_num || []
                }
            })).body?.is_right
            if (isRight) {
                const ok = (await quizApi.quizResultResultIdPut({
                    params: {
                        resultId: this.resultId
                    },
                    body: {
                        uid: this.uid,
                        quiz_id: this.quizId,
                        answer_seq_num: this.val.seq_id,
                        multi_answer_seq_num: this.val.multi_answer_seq_num || []
                    }
                })).body?.ok
                if (ok) {
                    this.isRight = true
                }
            } else {
                this.isRight = false
            }
            this.dialogVisible = true
        }
    },
    async mounted () {
        this.initData()
        this.getPageInfo()
    }
}
</script>

<style lang="less" scoped>
.help-page {
    /deep/.dialog-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 16px;
        padding: 1.9rem 0 3.45rem;
        img {
            width: 9.5rem;
            display: block;
            margin-bottom: 2.8125rem;
        }
        .result-word {
            color: #123E7F;
            font-weight: bolder;
            margin-bottom: 5.4rem;
        }
        .welcome-word {
            color: #123E7F;
            white-space: pre-line;
            text-align: center;
            width: calc(100% - 4.15rem);
            line-height: 1.5;
            margin-bottom: 3.15rem;
        }
    }
    .page-content {
        height: 100vh;
        display: flex;
        &.question {
            flex-direction: column;
            justify-content: space-between;
            .invite-info {
                color: #fff;
                font-size: 15px;
                font-weight: bolder;
                text-align: center;
                padding: 0 3.8rem;
                line-height: 1.5;
                margin-top: 5vh;
                margin-bottom: 5vh;
            }
            .question-wrap {
                background-color: #fff;
                margin: 0 11%;
                height: 65vh;
                padding: 2.85rem;
                box-sizing: border-box;
            }
            .que-content-warp {
                position: relative;
                margin: auto auto 0;
                background: #fff;
                flex: 1;
                padding: 2rem 1rem;
                width: calc(76vw - 2rem);
                height: 1;
                >div {
                    padding: 0 1rem;
                    width: calc(100% - 2rem);
                    max-height: 100%;
                    overflow: scroll;
                }
            }
            .btn {
                width: 12.8rem;
            }
            .content-bottom-wrap {
                flex: inherit;
                margin: 3rem auto;
            }
        }
        &.error {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            img {
                width: 9.35rem;
            }
            .error-tip {
                font-size: 18px;
                color: #fff;
                font-weight: bolder;
                margin-top: 3.35rem;
                text-align: center;
                white-space: pre-line;
                line-height: 1.5;
            }
        }
    }
}
</style>
